import fetch from "@lib/fetch";
import { API } from "../../config";
import { isAuthenticated } from "./auth";

export const createTicket = (data) => {
    return fetch(`${API}/v1/tickets`,{
      mode: 'cors',
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${isAuthenticated().token}`
      },
      body: JSON.stringify(data)
    })
    .then(res => {
      return res.json()
    })
    .catch(error => {
      console.log(error);
    })
  };

export const getTickets = (filters) => {
    let filterText = "";
    if (filters && filters.createdStartDate) {
      filterText = filterText + `created_start_date=${filters.createdStartDate}&created_end_date=${filters.createdEndDate}`
    };

    return fetch(`${API}/v1/tickets?${filterText}`,{
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${isAuthenticated().token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};
  
export const getTicket = (id) => {
    return fetch(`${API}/v1/tickets/${id}`,{
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${isAuthenticated().token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};
  

export const createTicketComment = (id,data) => {
    return fetch(`${API}/v1/tickets/${id}/comments`,{
        mode: 'cors',
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${isAuthenticated().token}`
        },
        body: JSON.stringify(data)
      })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};
  